<template>
    <div>         
        <h4 class="p-2">Saldos iniciales</h4>
        <vs-row class="mt-4">
            <vs-col sm="12" lg="3">
                <form autocomplete="off">
                    <label for="institucion" class="labelInput">
                        Institución
                    </label>
                    <vs-select filter class="aqui pt-0" id="institucion" placeholder="Seleccionar Institución" :key="institucionId" v-model="institucion" v-if="instituciones.length" :disabled="!instituciones.length">
                        <template #message-danger v-if="errorFields.includes('institucion')">
                            Requerido
                        </template>
                        <template v-if="instituciones.length" autocomplete="off">
                            <vs-option v-for="option in instituciones" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </template>
                        <template v-else>
                            <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                            </vs-option>
                        </template>
                    </vs-select>
                </form>
            </vs-col>
            <vs-col sm="12" lg="3">
                <form autocomplete="off">
                    <label for="cicloEscolar" class="labelInput">
                        Ciclo Escolar
                    </label>
                    <vs-select filter :loading="loadingCicloEscolar" class="aqui pt-0" id="cicloEscolar" placeholder="Seleccionar Ciclo Escolar" :key="cicloId" v-model="cicloEscolar" v-if="instituciones.length" :disabled="!ciclosEscolares.length">
                        <template #message-danger v-if="errorFields.includes('cicloEscolar')">
                            Requerido
                        </template>
                        <vs-option v-for="(option, index) in ciclosEscolares" :key="index"  :label="option.text" :value="option.id" @click="valorCiclo(index)">
                            {{option.text}}
                        </vs-option>
                    </vs-select>
                </form>
            </vs-col>
            <vs-col sm="12" lg="3">
                <div class="d-flex " style="justify-content: space-between;">
                    <label for="grupo" class="labelInput">
                        Grupo
                    </label>
                    <div class="d-flex" v-if="grupos[0]">
                        <div> 
                            <vs-tooltip>
                                <i class="fas fa-check-square" style="cursor:pointer" @click="selectAll(grupos, 'grupos')"></i>
                                <template #tooltip>
                                    Seleccionar todo
                                </template>
                            </vs-tooltip>
                        </div>
                        <div class="labelInput">
                            <vs-tooltip>
                                <i class="far fa-times-circle" style="cursor:pointer" @click="deseleccionarAll('grupos')"></i>
                                <template #tooltip>
                                    Deseleccionar todo
                                </template>
                            </vs-tooltip>
                        </div>
                        
                    </div>
                </div>
                <div style="position: relative">
                    <vs-select
                        filter
                        multiple
                        :loading="loadingGrupo"
                        collapse-chips
                        class="pt-0"
                        id="grupo"
                        placeholder="Seleccionar grupo"
                        :key="gruposId"
                        v-model="grupo"
                        :disabled="!grupos.length">
                        <template #message-danger v-if="errorFields.includes('grupo')">
                            Requerido
                        </template>
                        <vs-option v-for="option in grupos" :key="option.id"  :label="option.text" :value="option.id">
                            {{option.text}}
                        </vs-option>
                    </vs-select>
                    <div v-if="grupo !== ''" @click="deseleccionar('grupo')" class="tache">
                        <i class="far fa-times-circle"></i>
                    </div>
                </div>
            </vs-col>
            <vs-col sm="12" lg="3" style="margin-top: 23px; display: flex">
                <vs-button
                    @click="getSaldosIniciales()"
                >
                    <i class="fas fa-search mr-2"></i>Buscar
                </vs-button>
            </vs-col>
        </vs-row>
        <saldos-iniciales :users="users" :filtros="filtros" :institucion="institucion" :cicloEscolar="cicloEscolar" @refreshTable="getSaldosIniciales"></saldos-iniciales>
    </div>
</template>

<script>
import reportes from '../../../../api/requests/reportes.js'
import SaldosIniciales from './tabla-saldos-iniciales.vue'
export default {
    data(){
        return{
            institucion: '',
            instituciones: [],
            institucionId: (new Date()).getTime(),
            cicloEscolar: '',
            ciclosEscolares: [],
            cicloId: (new Date()).getTime(),
            grupo: '',
            grupos: [],
            gruposId: (new Date()).getTime(),
            errorFields: [],
            loadingCicloEscolar: false,
            loadingGrupo: false,
            users:[],
            cicloDefault:'',
            ciclosOrdenados:[],
            filtros: {}
        }
    },
    components:{
        SaldosIniciales
    },
    created(){
        this.getInstituciones()
    },
    methods: {
        selectAll(seleccion, tipo){
              let arr = []
            seleccion.forEach(i => {
              arr.push(i.id)
            })
            if(tipo == 'grupos'){
                this.grupo = arr
            }
        },
        async getInstituciones(){
            try {
                const response = await reportes.getInstitucion()
                this.instituciones = response.data
            }
            catch{
                
            }
        },
        valorCiclo(index){
            if(index > 0){
                const posicion = index - 1
                this.cicloDefault = this.ciclosEscolares[posicion].id
            }
        },
        async getCicloEscolar() {
            if(this.institucion){
                this.cicloEscolar = ''
                try {
                    this.loadingCicloEscolar = true
                    const { data: response } = await reportes.getCiclosEscolares(this.institucion)
                    this.ciclosEscolares = response
                    this.cicloId = (new Date()).getTime()
                    this.loadingCicloEscolar = false
                }catch(error){
                    this.loadingCicloEscolar = false
                    console.log(error)
                }
            }
        },
        async getGrupo() {
            if(this.cicloEscolar){
                this.grupo = []
                try {
                    this.loadingGrupo = true
                    let params = {
                        "ciclo_escolar_id": this.cicloEscolar
                    }
                    const { data: response } = await reportes.getGrupo(this.institucion, params)
                    this.grupos = response
                    this.gruposId = (new Date()).getTime()
                    this.loadingGrupo = false
                }
                catch(error){
                    this.loadingGrupo = false
                    console.log(error)
                }
            }
        },
        sanityForm () {
            this.errorFields = []
            if (!this.grupo) {
                this.errorFields.push('grupo')
            }
            if (!this.institucion) {
                this.errorFields.push('institucion')
            }
            if (!this.cicloEscolar) {
                this.errorFields.push('cicloEscolar')
            }
            if (!this.errorFields.length){
                
                let params = {
                    "institucion_id": this.institucion,
                    "ciclo_escolar_id": this.cicloEscolar,
                    "type_response": "online",
                }
                if(this.grupo[0] == ''){
                    const eliminar = this.grupo.shift()
                    params.grupo_id = this.grupo
                }else{
                    params.grupo_id = this.grupo
                }
                return params
            } else {
                return null
            }
        },
        async getSaldosIniciales() {
            const params = this.sanityForm()
            if(params){
                const loading = this.$vs.loading()
                try {
                    const { data: response } = await reportes.getSeguimientoInscripcion(params)
                    this.users = response
                    this.filtros = {
                        cicloDefault: this.cicloDefault,
                        institucion: this.institucion,
                        cicloEscolar: this.cicloEscolar,
                        ciclosEscolares: this.ciclosEscolares,
                        cicloId: (new Date()).getTime(),
                        grupo: this.grupo
                    }
                    loading.close()
                }
                catch{
                    loading.close()
                    
                }
            }
        },
    },
    watch:{
        institucion(){
            this.cicloEscolar = ''
            this.grupo = []
            this.users = []
            this.getCicloEscolar()
        },
        cicloEscolar(){
            this.getGrupo()
        }
    }
}
</script>

<style lang="scss" scoped>
    .cardReportes{
        width: 100%;
        background-color:white;
        justify-content: space-between;
        @media only screen and (max-width: 768px) {
            margin: 16px;
        }
        @media only screen and (min-width: 768px) {
            margin: 16px 30px;
        }
        border-radius: 3px;
        padding: 10px
    }
    .cardGeneral{
        @media only screen and (max-width: 768px) {
            width: 85%;
        }
        @media only screen and (min-width: 768px) {
            width: 95%;
        }
    }
    
    .tache{
        position: absolute;
        cursor: pointer;
        top: 10px;
        @media only screen and (max-width: 768px) {
            left: calc(95% - 4em);
        }
        @media only screen and (min-width: 768px) {
            left: calc(98% - 4em);
        }

    }
    .cien {
        width: 100px;
        background: none;
        display: inline-flex;
        justify-content: center;
        align-items: center;
    }
    .cienCincuenta {
        width: 150px;
        background: none;
        display: inline-flex;
        justify-content: center;
        align-items: center;
    }

    .mdChip{
        background: rgba($color: #000000, $alpha: 0.5);
        margin:1.7% 0;
        padding: 2% 6%;
        text-align: center;
        border-radius: 15px;
        font-size: 11px;
    }

</style>
<style scoped>
    /* .vs-table-content {
        overflow-x: auto !important;
    } */
    .vs-table{
        overflow-x: none;
    }
    .vs-table__td{
        padding-top: 0 !important;
    }
    .red {
        color: red;
        padding-left: 15px;
    }
</style>